export const LEGAL_AI_TOKEN_SYSTEM: string = `

### <!--= ++sectionIndex -->. AI Token System

Our AI services operate on a **token-based system**, where users purchase one-time token packages to access various AI-powered features. By purchasing and using tokens, you acknowledge and agree to the AI Token Policy, which is incorporated into these Terms of Use.

<!-- subSectionIndex = 0; -->

#### <!--= sectionIndex -->.<!--= ++subSectionIndex -->. Token Purchase & Expiry

- Token purchases are **one-time** and do not constitute a subscription.
- Tokens are valid for **one (1) year** from the date of purchase and will **automatically expire** if unused.
- Upon request, a **grace period of up to 30 days** for expired tokens may be granted at our discretion.
- Prices for token packages are **exclusive of VAT**, which will be calculated at checkout.
- Business customers within the EU may qualify for VAT exemption if a valid VAT ID is provided.

#### <!--= sectionIndex -->.<!--= ++subSectionIndex -->. Token Usage & Deduction

- Tokens are deducted when executing AI-related actions such as image generation, upscaling, background removal, and listing generation.
- The exact number of tokens required per action is displayed transparently before execution.

#### <!--= sectionIndex -->.<!--= ++subSectionIndex -->. Refund & Cancellation Policy

- A **14-day refund guarantee** applies **only if no tokens have been used**.
- Users waive their **14-day withdrawal right** upon purchase if tokens are used immediately, per the **EU Digital Content Directive (Directive 2019/770)**.
- Refunds for unused tokens are processed within **30 days of purchase** and may be issued either as a **token credit** or the **original payment method**, at our discretion.
- Token purchases are **final and non-refundable**, except where legally required.

#### <!--= sectionIndex -->.<!--= ++subSectionIndex -->. Non-Transferability & Compliance

- Tokens are **non-transferable** and can only be used within the purchasing user’s account.
- Sharing or reselling tokens is strictly prohibited and may lead to account suspension.

#### <!--= sectionIndex -->.<!--= ++subSectionIndex -->. AI Output Disclaimer

- AI-generated content is produced using machine learning models, and we **do not** guarantee its accuracy, originality, or legal compliance.
- Users assume full responsibility for reviewing and verifying AI-generated outputs.
- **All AI-generated content is permitted for commercial use**, provided users ensure compliance with applicable copyright and content laws.

#### <!--= sectionIndex -->.<!--= ++subSectionIndex -->. Modification of Terms

We may update these Terms of Use as necessary. Significant changes affecting token validity or usage will be communicated via email or in-app notifications at least **30 days prior to enforcement**.
`;
